import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router, ActivatedRoute } from '@angular/router';


import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-grid-end-user-privacy-policy',
  templateUrl: './grid-end-user-privacy-policy.component.html',
})
export class GridEndUserPrivacyPolicyComponent {






  loading: boolean = false;

  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {


    this.fetchPrivacy();



  }
  content;


  fetchPrivacy() {

    this.loading = true;

    const request = {
      Type: 'end-user-privacy'
    }



    this.httpService.post<any>('Store/fetch-settings', request, false).subscribe(
      resp => {
        this.content = JSON.parse(resp.message);

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }




}
